import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  infoElem: {
    display: props => props.display,
    justifyContent: props => props.justify,
    margin: props => props.margin
  },
  infoName: {
    fontFamily: "Montserrat",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#778899",
    marginRight: "15px"
  },
  infoValue: {
    fontFamily: "Montserrat",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#000000"
  }
});

const InfoField = ({
  name,
  value,
  justify = "flex-start",
  display = "flex",
  margin = "16px 0 0",
  color = "#000000",
  fieldMinWidth = "auto"
}) => {
  const { infoElem, infoName, infoValue } = useStyles();

  return (
    <div className={infoElem}
         style={{ justifyContent: justify, display: display, margin: margin }}>
      <div className={infoName} style={{minWidth: fieldMinWidth}}>{`${name}:`}</div>
      {value && (
        <div className={infoValue} style={{ color: color, marginTop: display === "block" ? "8px" : "0" }}>
          {value}
        </div>
      )}
    </div>
  );
};

export default InfoField;
